module.exports = __webpack_public_path__ + "img/bg-elder.d88c14e0.webp";